/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ViolationTypeEnumType } from "./ViolationTypeEnum"
import { RootStoreType } from "./index"


/**
 * ErrorDetailsDtoBase
 * auto generated base class for the model ErrorDetailsDtoModel.
 */
export const ErrorDetailsDtoModelBase = ModelBase
  .named('ErrorDetailsDto')
  .props({
    __typename: types.optional(types.literal("ErrorDetailsDto"), "ErrorDetailsDto"),
    violations: types.union(types.undefined, types.null, types.array(ViolationTypeEnumType)),
    total_num_unscheduled_orders: types.union(types.undefined, types.null, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ErrorDetailsDtoModelSelector extends QueryBuilder {
  get violations() { return this.__attr(`violations`) }
  get total_num_unscheduled_orders() { return this.__attr(`total_num_unscheduled_orders`) }
}
export function selectFromErrorDetailsDto() {
  return new ErrorDetailsDtoModelSelector()
}

export const errorDetailsDtoModelPrimitives = selectFromErrorDetailsDto().violations.total_num_unscheduled_orders
